"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistance = exports.pluralize = exports.isObjectEmpty = exports.calculateVAT = exports.calculateSubtotal = exports.calculateSubtotalWithVAT = exports.totalBasket = exports.productTotal = void 0;
var productTotal = function (product) {
    if (!product)
        return 0;
    var total = 0;
    total += product.total_price || 0;
    product.modifier_groups.forEach(function (category) {
        category.modifier_items.forEach(function (mod) {
            if (mod.checked && mod.price != null) {
                total += (mod.tax_percent != null
                    ? mod.price * (mod.tax_percent / 100 + 1)
                    : mod.price);
            }
        });
    });
    total *= product.quantity;
    return total;
};
exports.productTotal = productTotal;
var totalBasket = function (items) {
    if (!items)
        return 0;
    var total = 0;
    items.forEach(function (product) {
        total += (0, exports.productTotal)(product);
    });
    return total;
};
exports.totalBasket = totalBasket;
var calculateSubtotalWithVAT = function (items) {
    var subtotal = 0.0;
    items.forEach(function (item) {
        var totalItem = item.total_price || 0;
        item.modifier_groups.forEach(function (category) {
            category.modifier_items.forEach(function (mod) {
                if (mod.checked && mod.price != null) {
                    totalItem += mod.tax_percent != null
                        ? mod.price * (mod.tax_percent / 100 + 1)
                        : mod.price;
                }
            });
        });
        totalItem *= item.quantity;
        subtotal += totalItem;
    });
    return subtotal;
};
exports.calculateSubtotalWithVAT = calculateSubtotalWithVAT;
var calculateSubtotal = function (items) {
    var subtotal = 0;
    items.forEach(function (item) {
        var totalItem = item.price || 0;
        item.modifier_groups.forEach(function (category) {
            category.modifier_items.forEach(function (mod) {
                if (mod.checked && mod.price != null) {
                    totalItem += mod.price;
                }
            });
        });
        totalItem *= item.quantity;
        subtotal += totalItem;
    });
    return subtotal;
};
exports.calculateSubtotal = calculateSubtotal;
var calculateVAT = function (items) {
    var subtotal = 0.0;
    items.forEach(function (item) {
        var totalItem = item.tax_percent != null && item.price != null
            ? item.price / (100 + item.tax_percent) * item.tax_percent
            : 0;
        subtotal += totalItem * item.quantity;
    });
    return subtotal;
};
exports.calculateVAT = calculateVAT;
var isObjectEmpty = function (obj) {
    return Object.keys(obj).length === 0;
};
exports.isObjectEmpty = isObjectEmpty;
var pluralize = function (number, one, two, five) {
    var n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
};
exports.pluralize = pluralize;
var radians = function (x) {
    return x * Math.PI / 180;
};
var getDistance = function (p1, p2) {
    var R = 6378137;
    var dLat = radians(p2.lat - p1.lat);
    var dLong = radians(p2.lng - p1.lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(radians(p1.lat)) * Math.cos(radians(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
exports.getDistance = getDistance;
